<template>
<div>
<div class="mt-12" v-if="loading"> <Loading> </Loading> </div>
<v-container v-if="!loading" elevation="0">
<v-card-title>
    <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field> 
</v-card-title>
    <v-data-table
      :headers="headers"
      :items="getClientDisposals"
      :options.sync="options"
      :search="search"
      class="elevation-1"
    >
    </v-data-table>
</v-container>
</div>
</template>
<script>
import Loading from "@/components/Loading";
export default {
  name: 'ClientDisposalTable',
  components: { Loading },
  data() {
    return {
      headers: [
        {
          text: 'Booking',
          align: 'start',
          sortable: true,
          value: 'order',
          filterable: true,
        },
        { text: 'Date', value: 'date' },
        { text: 'Address', value: 'address' },
        { text: 'Waste', value: 'wasteName' },
        { text: 'Vehicle', value: 'vehicleName' },
        { text: 'Driver', value: 'driverName' },
        { text: 'Type', value: 'type' },
        { text: 'Status', value: 'status' },
        { text: 'Charge (ZAR)', value: 'cost' }
      ],
      options: {
        page: 1,
        pageSize: 25
      },
      search: '',
      loading: true
    }
  },
  watch: {
      getClientDisposals(bookings){
        if (bookings.length < 1) {
            alert('There are no available booking history yet');
            this.loading = false;
        }else{
          this.loading = false;
        }
    }
  },
  computed: {   
    getUser() {
      return this.$store.getters['auth/getUser'];
    },
    getClientDisposals(){
      return this.$store.getters.getClientDisposals;
    }
  },
  async mounted() {    
      await this.$store.dispatch('fetchClientDisposals', this.getUser.id); 
  }
}
</script>

<style scoped>

</style>